// Resources
import API from "../helpers/API"

/**
 * Componente funcional para manipulacão dos dados de combos
 */
const CompanyController = {
  fetchAll(withModality = true, companyIds = []) {
    return API.request("/v1/company/all", { withModality, companyIds, stStatus: true }, "GET")
  },

  fetchOne() {
    return API.request("/v1/company", [], "GET", {}, 60000)
  },

  fetchOneSimple() {
    return API.request("/v1/company/simple", [], "GET", {}, 60000)
  },

  fetchPayments() {
    return API.request("/v1/company/payments", { st_website: true }, "GET")
  },

  fetchWorkingPeriods() {
    return API.request("/v1/company/working/periods", [], "GET")
  },

  fetchAddress() {
    return API.request("/v1/company/address", [], "GET")
  },

  fetchIntegrations(companies = null) {
    const params = { companies }
    return API.request("/v1/company/integrations", params, "GET")
  },

  fetchWorkingHours() {
    return API.request("/v1/company/working/hours", [], "GET")
  },

  fetchInitialData() {
    return API.request("/v1/company/site/initial", [], "GET")
  },
}

export default CompanyController
